import React from "react";
import "./PlanUpgradeNeededModal.scss";

import { useSelector } from "react-redux";
import Modal from "src/app/components/Modal/Modal";
import { RootState } from "src/redux/reducers";
import PlanUpgradeNeededBox from "../../components/PlanUpgradeNeededBox/PlanUpgradeNeededBox";

interface Props {
  onClose: () => void;
}

function PlanUpgradeNeededModal(props: Props) {
  const { onClose } = props;

  const { planUpgradeNeededModalContext } = useSelector(
    (state: RootState) => state.subscriptionReducer,
  );

  return (
    <Modal
      className="plan-upgrade-needed-modal"
      overlayClassName="plan-upgrade-needed-modal__overlay"
      onClose={onClose}
    >
      <PlanUpgradeNeededBox
        feature={planUpgradeNeededModalContext}
        onClose={onClose}
      />
    </Modal>
  );
}

export default PlanUpgradeNeededModal;
